// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import condiciones from "./Condiciones";

import { BButton, BFormTextarea, BListGroup, BToast, BImg, BListGroupItem, ToastPlugin, BFormInput } from 'bootstrap-vue';
Vue.component('b-button', BButton)
Vue.component('b-toast', BToast)
Vue.component('b-form-textarea', BFormTextarea)
Vue.component('b-list-group', BListGroup)
Vue.component('b-toast', BToast);
Vue.component('b-img', BImg);
Vue.component('b-list-group-item', BListGroupItem)
Vue.component('b-form-input', BFormInput)
Vue.use(ToastPlugin)

//import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import Clipboard from "v-clipboard";

Vue.use(Clipboard);

Vue.directive('focus', {
  // Cuando el elemento enlazado se inserta en el DOM...
  inserted: function (el) {
    // Enfoca el elemento
    el.focus()
  }
})

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js